import React, { useEffect, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

/* ---- Brand ---- */
const BRAND = "#4CB1A1";
const BRAND_HOVER = "#2B8D80";

/* ---- ICONS (Bootstrap-like, controlados por className) ---- */
const Icons = {
      intro: (cls="") => (
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-text-fill" viewBox="0 0 16 16">
  <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1"/>
</svg>
  ),
  cookie: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0a8 8 0 1 0 8 8c0-.55-.045-1.086-.132-1.607A2 2 0 0 1 13.5 4.5a2 2 0 0 1-2-2A2 2 0 0 1 9 .132 8.1 8.1 0 0 0 8 0M5.5 6A1.5 1.5 0 1 1 7 7.5 1.5 1.5 0 0 1 5.5 6m5 1a1 1 0 1 1-1 1 1 1 0 0 1 1-1M6 10a1 1 0 1 1-1 1 1 1 0 0 1 1-1"/>
    </svg>
  ),
  graph: (cls="") => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-puzzle-fill" viewBox="0 0 16 16">
  <path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.5.5 0 0 0-.115.118l-.012.025L6.5 4.5v.003l.003.01q.005.015.036.053a.9.9 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.9.9 0 0 0 .271-.194.2.2 0 0 0 .036-.054l.003-.01v-.008l-.012-.025a.5.5 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.5.5 0 0 0 .115-.118l.012-.025.001-.006v-.003l-.003-.01a.2.2 0 0 0-.036-.053.9.9 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11s-.912.1-1.19.24a.9.9 0 0 0-.271.194.2.2 0 0 0-.036.054l-.003.01v.002l.001.006.012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238z"/>
</svg>
  ),
  gear: (cls="") => (
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-toggle2-off" viewBox="0 0 16 16">
  <path d="M9 11c.628-.836 1-1.874 1-3a4.98 4.98 0 0 0-1-3h4a3 3 0 1 1 0 6z"/>
  <path d="M5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1A5 5 0 1 0 5 3a5 5 0 0 0 0 10"/>
</svg>
  ),
  palette: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0a8 8 0 1 0 4.906 14.32c.52-.45.756-1.15.64-1.83-.1-.6-.51-1.16-1.14-1.23l-1.64-.18c-.42-.05-.77-.35-.88-.76-.18-.66.35-1.26 1-1.26h1.02c1.1 0 2-.9 2-2A7 7 0 0 0 8 0M4.5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2m2-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m1 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
    </svg>
  ),
  megaphone: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M3 11v2a1 1 0 0 0 1.447.894L7 13v-2l-2.553-.894A1 1 0 0 0 3 11z"/>
      <path d="M14 3a1 1 0 0 1 1 1v6a1 1 0 0 1-1.555.832L9 8.5V4.668L12.445 3.168A1 1 0 0 1 14 3zM8 4.5v4L4 11V2l4 2.5z"/>
    </svg>
  ),
  target: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m0-2A6 6 0 1 1 8 2a6 6 0 0 1 0 12"/>
      <path d="M8 11A3 3 0 1 0 8 5a3 3 0 0 0 0 6"/>
    </svg>
  ),
  link: (cls="") => (
    <svg className={cls} viewBox="0 0 16 16" fill="currentColor">
      <path d="M6.354 5.5H4a3 3 0 1 0 0 6h2.354a.5.5 0 0 0 0-1H4a2 2 0 1 1 0-4h2.354a.5.5 0 0 0 0-1z"/>
      <path d="M10 4.5h2a3 3 0 1 1 0 6h-2a.5.5 0 1 1 0-1h2a2 2 0 1 0 0-4h-2a.5.5 0 1 1 0-1z"/>
      <path d="M5.5 8a.5.5 0 0 1 .5-.5h4.5a.5.5 0 1 1 0 1H6a.5.5 0 0 1-.5-.5z"/>
    </svg>
  ),
  warn: (cls="") => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
</svg>
  ),
  mail: (cls="") => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247m2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
</svg>
  ),
};

/* ---- SECTIONS ---- */
const SECTIONS = [
  { id: "overview", title: "Cookies", icon: "intro" },
  { id: "what", title: "What are cookies?", icon: "cookie" },
  { id: "types", title: "Types of cookies we use", icon: "graph" },
  { id: "disable", title: "How to disable cookies", icon: "gear" },
  { id: "third", title: "Third-party cookies", icon: "link" },
  { id: "warning", title: "Warning about deleting cookies", icon: "warn" },
  { id: "contact", title: "Questions about this policy", icon: "mail" },
];

export default function CookiesPolicy() {
  const tocRef = useRef(null);

  useEffect(() => {
    const links = Array.from(tocRef.current?.querySelectorAll("a[data-id]") || []);
    const ids = links.map(a => a.getAttribute("data-id"));
    const sections = ids.map(id => document.getElementById(id)).filter(Boolean);

    const io = new IntersectionObserver(
      (entries) => {
        const vis = entries.filter(e => e.isIntersecting)
          .sort((a,b)=> b.intersectionRatio - a.intersectionRatio)[0]?.target.id;
        if (vis) {
          links.forEach(a => a.setAttribute(
            "aria-selected", a.getAttribute("data-id") === vis ? "true" : "false"
          ));
        }
      },
      { rootMargin: "-30% 0px -60% 0px", threshold: [0,0.15,0.3,0.6,1] }
    );
    sections.forEach(s => io.observe(s));

    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const max = document.documentElement.scrollHeight;
      if (scrolled >= max - 2) {
        const lastId = ids[ids.length - 1];
        links.forEach(a => a.setAttribute("aria-selected", a.getAttribute("data-id") === lastId ? "true" : "false"));
      }
      if (window.scrollY <= 1) {
        const firstId = ids[0];
        links.forEach(a => a.setAttribute("aria-selected", a.getAttribute("data-id") === firstId ? "true" : "false"));
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const onClick = (e) => {
      const id = e.currentTarget.getAttribute("data-id");
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      target.classList.add("ring-4","ring-[color:rgba(13,148,136,0.25)]","transition-shadow","duration-700");
      setTimeout(()=> target.classList.remove("ring-4","ring-[color:rgba(13,148,136,0.25)]"), 800);
    };
    links.forEach(a => a.addEventListener("click", onClick));

    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
      links.forEach(a => a.removeEventListener("click", onClick));
    };
  }, []);

  const iconMenuCls = "w-4 h-4 flex-none text-slate-600";
  const iconCardCls = "w-5 h-5";
  const brandLinkCls = `underline underline-offset-2 decoration-transparent hover:decoration-current transition-colors text-[${BRAND}] hover:text-[${BRAND_HOVER}]`;

  const Card = ({ id, title, icon, children }) => (
    <section id={id} className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 sm:p-6 mb-5 scroll-mt-28">
      <h2 className="flex items-center gap-3 text-slate-900 font-semibold text-lg">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-600">
          {Icons[icon](iconCardCls)}
        </span>
        {title}
      </h2>
      <div className="mt-3 text-slate-700 leading-relaxed">{children}</div>
    </section>
  );

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />

      {/* Header */}
      <header className="border-b bg-slate-50">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Cookies Policy</h1>
          <div className="mt-2 h-0.5 w-16 rounded-full" style={{ backgroundColor: BRAND }} />
          <p className="mt-2 text-slate-500">How and why we use cookies on our website.</p>
        </div>
      </header>

      {/* Body */}
      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-4 sm:gap-6">
          {/* Sidebar */}
          <aside className="md:sticky md:top-24 self-start">
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-3">
              <p className="px-2 pb-2 text-[13px] font-medium text-slate-500">Quick Navigation</p>
              <nav ref={tocRef}>
                <ul className="space-y-1">
                  {SECTIONS.map(({ id, title, icon }) => (
                    <li key={id}>
                      <a
                        data-id={id}
                        href={`#${id}`}
                        aria-selected="false"
                        className="
                          group relative flex items-center gap-3 rounded-lg px-3 py-2
                          text-[14px] text-slate-700 hover:bg-teal-50
                          aria-selected:bg-teal-50
                        "
                      >
                        {Icons[icon](iconMenuCls)}
                        <span className="flex-1">{title}</span>
                        <span
                          className="
                            pointer-events-none absolute left-0 top-1 bottom-1 w-0.5 rounded
                            bg-teal-500 opacity-0 transition-opacity duration-200
                            group-hover:opacity-100 group-aria-selected:opacity-100
                          "
                        />
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </aside>

          {/* Content */}
          <div>
            <Card {...SECTIONS[0]}>
              <p>
                The Website <a className={brandLinkCls} href="https://invisiblecloud.pt">https://invisiblecloud.pt</a> uses cookies.
              </p>
              <p className="mt-3">
                In compliance with Regulation (EU) 2016/679 (GDPR), this page explains our policy for collecting and processing cookies.
              </p>
            </Card>

            <Card {...SECTIONS[1]}>
              <p>
                A cookie is a small file stored on your device when you visit certain pages. It lets a website
                store and retrieve information about your browsing habits and, depending on how you use your device,
                can be used to recognize you.
              </p>
            </Card>

            <Card {...SECTIONS[2]}>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
          
                  <p><strong>Analysis cookies:</strong> set by us or third parties to count users and measure usage
                  for statistical analysis to improve our services.</p>
                </li>
                <li className="flex items-start gap-3">
                  <p><strong>Technical cookies:</strong> enable navigation in restricted areas and core functions
                  (e.g., completing a purchase flow).</p>
                </li>
                <li className="flex items-start gap-3">
                  <p><strong>Personalization cookies:</strong> apply default preferences such as language or browser type.</p>
                </li>
                <li className="flex items-start gap-3">
                  <p><strong>Advertising cookies:</strong> manage ad spaces and tailor ads to the requested service or your site usage.</p>
                </li>
                <li className="flex items-start gap-3">
                  <p><strong>Behavioral advertising cookies:</strong> manage ad spaces using profiles built from
                  observed browsing habits.</p>
                </li>
              </ul>
            </Card>

            <Card {...SECTIONS[3]}>
              <p>
                You can allow, block or delete cookies in your browser settings. Most browsers let you manage cookies easily:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>
                  <a className={brandLinkCls} href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox">Firefox</a>
                </li>
                <li>
                  <a className={brandLinkCls} href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">Safari</a>
                </li>
                <li>
                  <a className={brandLinkCls} href="https://support.google.com/chrome/answer/95647?hl=en">Google Chrome</a>
                </li>
              </ul>
            </Card>

            <Card {...SECTIONS[4]}>
              <p>
                We use Google AdSense and Google Analytics for statistics and advertising. Some cookies are essential
                for site operation (e.g., internal search).
              </p>
              <p className="mt-3">
                This site also includes third-party features to share content on social networks such as
                <span> </span>
                <a className={brandLinkCls} href="https://facebook.com">Facebook</a>,{" "}
                <a className={brandLinkCls} href="https://twitter.com">Twitter</a>{" "}
                and{" "}
                <a className={brandLinkCls} href="https://plus.google.com">Google+</a>.
              </p>
            </Card>

            <Card {...SECTIONS[5]}>
              <p>
                You can delete and block all cookies from this site, but some parts may not work correctly or the overall experience
                may be affected.
              </p>
            </Card>

            <Card {...SECTIONS[6]}>
              <p>
                Questions about our cookie policy? Contact us at{" "}
                <a className={brandLinkCls} href="mailto:info@invisiblecloud.pt">info@invisiblecloud.pt</a>.
              </p>
            </Card>
          </div>
        </div>
 
      </main>
             <Footer />
    </div>
  );
}